const g = require('globals')
const FreeForm = require('module/freeform/freeform')
const template = require('./svg_captcha.html')
const styles = require('./svg_captcha.less')
const browser = require('module/browser/browser')
const log = require('log').create('signup', 'captcha') // eslint-disable-line


const SvgCaptchaView = FreeForm.FormView.extend({

    displayName: 'SvgCaptchaView',

    template,

    styles,

    initialize(options) {
        this.captcha_text = new FreeForm.Element({
            el: '.captcha-text',
            type: 'text',
            className: 'input large fullwidth',
            placeholder: 'Enter the characters shown above',
        })

        this.model = new FreeForm.Form({
            captcha_url: this.getCaptchaUrl(),
            elements: [
                this.captcha_text,
            ],
        })

    },

    getCaptchaUrl() {
        return `${g.NODE_API}/captcha/captcha.svg?t=${Date.now()}`
    },

    onAttach() {
        if (browser.isNot('touch')) {
            this.$('input').first().focus()
        }
    },

})

module.exports = SvgCaptchaView
